/**
 * "Írj az irodának" — a WhatsApp chat with the office, the one way the
 * driver portal sends a driver to the office (drivers message it; no screen
 * ever tells them to call). The number is config's PH_OFFICE_WHATSAPP and
 * the link is the shared `whatsappUrl`, optionally with a message typed in.
 *
 * Used on the gate (dark screen) and in the day screen's profile menu.
 */
import React from 'react';
import { PH_OFFICE_WHATSAPP } from '../../../config/config';
import { whatsappUrl } from '../../../Utils/contactLinks';
import { WhatsAppIcon } from './Icons';

export default function OfficeWhatsAppButton({ message = '', className = '' }) {
  return (
    <a
      className={['pp-btn pp-btn--outline pp-btn--block pp-btn--contact', className].filter(Boolean).join(' ')}
      href={whatsappUrl(PH_OFFICE_WHATSAPP, message)}
      target="_blank"
      rel="noreferrer"
    >
      <WhatsAppIcon size={19} />
      Írj az irodának
    </a>
  );
}
